<template>
	<DsQuantitySelector
		:model-value="context._value"
		:id="context.id"
		:name="context.node.name"
		:ariaLabelInput="resolvedAriaLabelInput"
		:ariaLabelDecreaseQuantity="resolvedAriaLabelDecrease"
		:ariaLabelIncreaseQuantity="resolvedAriaLabelIncrease"
		:background="context.background"
		:disabled="props.context.disabled"
		:outline="context.outline"
		:min="resolvedMinValue"
		:max="resolvedMaxValue"
		:input-attrs="context.attrs"
		@update:modelValue="onUpdate"
		@blur="onBlur"
	/>
</template>

<script setup lang="ts">
import { DsQuantitySelector } from "@coloplast/design-system";
import "@coloplast/design-system/dist/components/quantity-selector/ds-quantity-selector.css";
import type { QuantityContext } from "./QuantityCounterElement.types";
import { computed, onMounted } from "vue";

const props = defineProps<{
	context: QuantityContext;
}>();

const resolvedMaxValue = computed(() =>
	props.context.max && props.context.max > 0 ? props.context.max : undefined,
);

const resolvedMinValue = computed(() =>
	props.context.min && props.context.min > 0 ? props.context.min : undefined,
);

const resolvedAriaLabelInput = computed(
	() => props.context.ariaLabelInput ?? props.context.label ?? "Quantity",
);
const resolvedAriaLabelDecrease = computed(
	() => props.context.ariaLabelDecreaseQuantity ?? "Decrease quantity",
);
const resolvedAriaLabelIncrease = computed(
	() => props.context.ariaLabelIncreaseQuantity ?? "Increase quantity",
);

onMounted(() => {
	if (typeof props.context._value === "string") {
		const n = Number(props.context._value);
		if (!Number.isNaN(n)) {
			props.context.node.input(n);
		}
	}
});

const onUpdate = (value: number) => {
	props.context.node.input(value);
	props.context.handlers.touch();
};

const onBlur = () => {
	props.context.handlers.blur();
};
</script>

<style lang="scss">
.formkit-outer[data-type="quantity"] .formkit-inner {
	inline-size: fit-content !important;

	&:focus-within {
		outline: none;
	}
}
</style>
